export default __webpack_public_path__ + "static/stacked-bar-98dbda7fe27140c006d34eeb2dba24a3.png";